module.exports = __webpack_public_path__ + "static/display_sausage-55521adde8d0e0d84215cce01e51251b.jpg";